module.exports = __webpack_public_path__ + "static/media/bkg-white-logo-reg-vivescia.e8ffeace.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bkg-white-logo-reg-vivescia.svg
// module id = 728
// module chunks = 0